import '../styles/menu.scss';
import "../styles/compta.scss";

import Redirection from './Redirection';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import React from 'react';
import gsap from 'gsap';

const { useRef, useState, useEffect, createRef } = React;


/*--------------------
Items
--------------------*/

const couleur = "#e38408";
const items = [
    {
        name: "Accueil",
        color: couleur,
        href: "/accueil"
    },

    {
        name: "Compta",
        color: couleur,
        href: "/compta"
    },

    {
        name: "Documents",
        color: couleur,
        href: "/documents"
    },

    {
        name: "Direction",
        color: couleur,
        href: "/direction"
    },

    {
        name: "Parametres",
        color: couleur,
        href: "/parametres"
    },

    {
        name: "Déconnexion",
        color: couleur,
        onclick: Deconnexion
    }];


/*--------------------
Menu
--------------------*/
const Menu = ({ items }) => {
    const url = window.location.pathname;
    const $root = useRef();
    const $indicator1 = useRef();
    const $indicator2 = useRef();
    const $items = useRef(items.map(createRef));
    const [active, setActive] = useState(items.findIndex(item => item.href === url));

    //recuperer l'index de l'item dans items en fonction de l'url 
    // setActive($items.findIndex(item => item.href === url));

    const animate = () => {
        const menuOffset = $root.current.getBoundingClientRect();
        const activeItem = $items.current[active].current;
        const { width, height, top, left } = activeItem.getBoundingClientRect();

        const settings = {
            x: left - menuOffset.x,
            y: top - menuOffset.y,
            width: width,
            height: height,
            // backgroundColor: items[active].color,
            ease: 'elastic.out(.7, .7)',
            duration: .8
        };


        gsap.to($indicator1.current, {
            ...settings
        });


        gsap.to($indicator2.current, {
            ...settings,
            duration: 1
        });

    };

    useEffect(() => {
        animate();
        window.addEventListener('resize', animate);

        return () => {
            window.removeEventListener('resize', animate);
        };
    }, [active]);

    return /*#__PURE__*/(
        React.createElement("div", {
            ref: $root,
            className: "menu"
        },

            items.map(function (item, index) {


                return React.createElement("div", {
                    className: "separateur"
                }, React.createElement("a", {
                    key: item.name,
                    ref: $items.current[index],
                    className: `item ${active === index ? 'active' : ''}`,
                    onMouseEnter: () => {
                        setActive(index);
                    },
                    onMouseLeave: () => {
                        setActive(items.findIndex(item => item.href === url));
                    },
                    href: item.href,
                    onClick: item.onclick
                }, item.name))

            }), /*#__PURE__*/


            React.createElement("div", {
                ref: $indicator1,
                className: "indicator"
            }), /*#__PURE__*/

            React.createElement("div", {
                ref: $indicator2,
                className: "indicator"
            })));



};


/*--------------------
App
--------------------*/
const App = () => {
    return /*#__PURE__*/(
        React.createElement("div", { className: "App" }, /*#__PURE__*/
            React.createElement(Menu, { items: items })));


};

function Deconnexion() {
    //requete a l'api pour supprimer le token de la base de données
    axios.post('http://localhost:5000/deconnexion', {}, {
        headers: {
            "authorization": "Bearer " + Redirection.getCookie("token")
        }
    })
        .then(function (response) {
            Redirection.clearCookie();
            window.location.href = "/login";
        })
}

/*--------------------
Render
--------------------*/
function Header() {

    const rootNode = document.getElementById('root');
    console.log(rootNode);

    return /*#__PURE__*/React.createElement(App, null);
}

export default Header;